<template>
  <div class="leading-normal tracking-normal bg-gray-100" id="main-body">
    <RouterView />
  </div>
</template>

<script lang="ts" setup>
</script>